import { render, staticRenderFns } from "./AdminStock.vue?vue&type=template&id=4d827c79&"
import script from "./AdminStock.vue?vue&type=script&lang=js&"
export * from "./AdminStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports